import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { Client } from "../types/Client/Client";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";

@Injectable({
  providedIn: "root",
})
export class AvailableClientRepository extends ArrayStorageRepository<Client> {
  constructor(storage: Storage) {
    super(storage, "availableClients", "clientID");
  }
}
